import { setAdmin, setAdmins, setLoading } from "../../store/slices/admin-user";
import { AppDispatch } from "../../store/store";
import axiosInstance from "../../utility/axios";
import { getErrorMessage } from "../apiError";
import { toast } from "sonner";
import { IApiResponse } from "@/src/store/types/api-response";
import {
  IAdminUser,
  IAdminUserResponseData,
} from "@/src/store/types/admin-users";

const adminEndpoint = "/api/v1/admin/admins";

export const get_admin_users = async (
  dispatch: AppDispatch,
  limit: number,
  offset: number,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<
      IApiResponse<IAdminUserResponseData>
    >(`${adminEndpoint}`, {
      params: { limit, offset },
    });
    dispatch(setAdmins(response.data));
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to load admin users"));
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_admin_user = async (id: number, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<IApiResponse<IAdminUser>>(
      `${adminEndpoint}/${id}`,
    );
    dispatch(setAdmin(response.data.data));
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to load admin user"));
  } finally {
    dispatch(setLoading(false));
  }
};
